import { Component, Input, OnInit } from "@angular/core";
import { SharedFormService } from "src/app/shared-utility/services/shared-form.service";
import { ToastrService } from "ngx-toastr";
import { SharedStateService } from "src/app/shared-utility/services/shared-state.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
})
export class ResetPasswordComponent implements OnInit {
  newPassword: string = "";
  blnHasCapital: boolean = false;
  blnHasOneNumber: boolean = false;
  blnHasSpecialChar: boolean = false;
  blnHasLength: boolean = false;
  blnLowerCase: boolean = false;
  confirmNewPassword: string = "";
  prevPasswordResults: any = null;
  resetPasswordResponse: any;
  @Input() loginScreenPassword :string;
  @Input() passwordResetRequired :boolean;
  blnPasswordBoxValid = false;
  
  constructor(
    private formDataSvc: SharedFormService,
    private toastr: ToastrService,
    private sharedStateSvc: SharedStateService,
    private router: Router
  ) {}
  ngOnInit() {}

  checkpassword(event: any): void {
    const specialCharCheck = /[ `!@#$%^&*]/;
    const capitalCheck = /[A-Z]+/;
    const lengthCheck = event && event.length > 7 && event.length < 31;
    const oneNumber = /.*[0-9].*/;
    const lowerCaseCheck = /[a-z]+/;

    this.blnHasCapital = capitalCheck.test(event);
    this.blnHasLength = lengthCheck;
    this.blnHasOneNumber = oneNumber.test(event);
    this.blnHasSpecialChar = specialCharCheck.test(event);
    this.blnLowerCase = lowerCaseCheck.test(event);
    this.blnPasswordBoxValid = (this.blnHasCapital && this.blnLowerCase && this.blnHasOneNumber && this.blnHasSpecialChar && this.blnHasLength);
  }

  passwordValidation(isFirstPassword: any): any {
    return (checkValue: any) => {
      const specialCharCheck = /[ `!@#$%^&*]/;
      const capitalCheck = /[A-Z]+/;
      const lengthCheck = checkValue.length > 7 && checkValue.length < 31;
      const oneNumber = /.*[0-9].*/;
      const lowerCaseCheck = /[a-z]+/;
      return {
        hasSpecial: specialCharCheck.test(checkValue),
        hasCapital: capitalCheck.test(checkValue),
        hasLength: lengthCheck,
        hasOneNumber: oneNumber.test(checkValue),
        hasPasswordMatch: false,
        hasLowerCase: lowerCaseCheck.test(checkValue),
        currentValue: checkValue,
        firstPasswordField: isFirstPassword,
        verbiage: " Does not meet requirements",
      };
    };
  }

  confirmPasswords(isFirstPassword: any): any {
    return (checkValue: any) => {
      if (this.prevPasswordResults && !isFirstPassword) {
        this.prevPasswordResults = {
          ...this.prevPasswordResults,
          firstPasswordField: isFirstPassword,
          verbiage: "Passwords do not match",
          hasPasswordMatch:
            checkValue === this.prevPasswordResults.currentValue,
        };
      }
      return this.prevPasswordResults;
    };
  }

  confirmPasswordd() {
    const finalPayload = {
      UserName: this.sharedStateSvc.PrimaryState.prescriberInfo.username,
      CurrentPassword: this.loginScreenPassword,
      Password: this.newPassword,
      PasswordConfirmation: this.confirmNewPassword,
    };
    this.formDataSvc.hideLoader.next(true);
    this.resetPasswordResponse =this.sharedStateSvc.changePass(finalPayload).subscribe(
      (resp: any) => {
        this.formDataSvc.hideLoader.next(false);
        localStorage.setItem("ResetPasswordRequired","false");
        this.toastr.success("Password changed successfully!");
        this.formDataSvc.passwordResetRequired.next(false);
      },
      (error: any) => {
        this.formDataSvc.hideLoader.next(false);
        this.toastr.error("There was an error in Reset Password!");
      }
    );

  }

  redirectLogin(): void{
    this.formDataSvc.passwordResetRequired.next(false);
  }
}
